import { Component } from '@angular/core';

@Component({
  selector: 'wchfs-option-prefix',
  template: ` <ng-content></ng-content>`,
  styleUrls: ['./option-prefix.component.scss'],
})
export class OptionPrefixComponent {}
